module.exports = __webpack_public_path__ + "img/file.faa609fb.svg";